/* Lux Drawer Portal
   Moves the mobile menu drawer to <body> on open (escaping sticky-header's
   containing block so position:fixed works), injects a close (X) button,
   and restores everything on close. */
(function () {
  'use strict';

  var panel = null;
  var placeholder = null;
  var originalParent = null;
  var closeBtn = null;

  function getPanel() {
    return document.querySelector('header-drawer .menu-drawer') ||
           document.querySelector('body > .menu-drawer');
  }

  function getDetails() {
    return document.querySelector('header-drawer details');
  }

  function ensureCloseButton() {
    if (closeBtn || !panel) return;
    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'lux-drawer-close';
    closeBtn.setAttribute('aria-label', 'Close menu');
    closeBtn.innerHTML = '<span aria-hidden="true">&times;</span>';
    closeBtn.addEventListener('click', closeDrawer);
    panel.appendChild(closeBtn);
  }

  function closeDrawer() {
    portalBack();
    var details = getDetails();
    if (details) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    }
    // The container itself also carries menu-opening
    var container = document.querySelector('.menu-drawer-container');
    if (container) container.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    var summary = document.querySelector('header-drawer summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');

    // Header may have been in the scrolled-down hidden state before the drawer
    // opened (menu-open temporarily forced it visible). Clear the hidden state
    // on close so it doesn't snap back up out of view.
    var sh = document.querySelector('.section-header');
    if (sh) {
      sh.classList.remove('shopify-section-header-hidden');
    }
  }

  function portalOut() {
    panel = getPanel();
    if (!panel || panel.dataset.portaled === 'true') return;
    originalParent = panel.parentNode;
    placeholder = document.createComment('menu-drawer-placeholder');
    originalParent.insertBefore(placeholder, panel);
    document.body.appendChild(panel);
    panel.dataset.portaled = 'true';
    ensureCloseButton();
  }

  function portalBack() {
    if (!panel || panel.dataset.portaled !== 'true') return;
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(panel, placeholder);
      placeholder.parentNode.removeChild(placeholder);
    }
    panel.dataset.portaled = 'false';
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('header-drawer summary');
    if (!summary) return;
    requestAnimationFrame(function () {
      var details = getDetails();
      if (details && details.hasAttribute('open')) {
        portalOut();
      } else {
        portalBack();
      }
    });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var details = getDetails();
      if (details && details.hasAttribute('open')) closeDrawer();
    }
  });
})();